import { Tabs } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { AppContext } from '../../../../../AppContext';
import { PERMISSIONS_KEY, ROUTES, TABS } from '../../../../../common/constants';
import { filterTabsByPermissions } from '../../../../../common/utils';

const LibraryTabs = ({ children }) => {
  const history = useHistory();
  const location = useLocation();
  const {
    state: { permissions },
  } = useContext(AppContext);
  const [activeTabKey, setActiveTabKey] = useState(TABS?.INVOICES?.key);

  const tabList = [
    {
      key: TABS?.INVOICES?.key,
      label: TABS?.INVOICES?.label,
      children,
      permissionKey: PERMISSIONS_KEY?.PAYMENTS_LIBRARY,
    },
    {
      key: TABS?.REFERRAL?.key,
      label: TABS?.REFERRAL?.label,
      children,
      permissionKey: PERMISSIONS_KEY?.PAYMENTS_LIBRARY,
    },
  ];

  const filteredTabs = filterTabsByPermissions(tabList, permissions);

  useEffect(() => {
    if (location?.pathname?.includes(ROUTES?.INVOICES)) {
      setActiveTabKey(TABS?.INVOICES?.key);
    }
    if (location?.pathname?.includes(ROUTES?.REFERRAL)) {
      setActiveTabKey(TABS?.REFERRAL?.key);
    }
  }, [location]);

  const onTabChange = (key) => {
    setActiveTabKey(key);
    switch (key) {
      case TABS?.INVOICES?.key:
        history?.push(
          `${ROUTES?.PAYMENTS}${ROUTES?.LIBRARY}${ROUTES?.INVOICES}`,
        );
        break;
      case TABS?.REFERRAL?.key:
        history?.push(
          `${ROUTES?.PAYMENTS}${ROUTES?.LIBRARY}${ROUTES?.REFERRAL}`,
        );
        break;
      default:
        break;
    }
  };

  return (
    <div className="card-container">
      <Tabs
        activeKey={activeTabKey}
        type="card"
        className="full-width"
        onChange={(key) => onTabChange(key)}
        items={filteredTabs}
        destroyInactiveTabPane
      />
    </div>
  );
};

export default LibraryTabs;
